import Bugsnag from "@bugsnag/js";
import React from "react";
import { useRouteError } from "react-router-dom";
import { errorLog } from "../utils/logger";

export const NotFound = () => {
  const error: any = useRouteError();
  errorLog(error as Error);
  Bugsnag.notify(error);

  return (
    <div className="is-flex is-justify-content-center is-align-items-center p-6 is-flex-direction-column">
      <h1 className="is-size-3 mt-5">Uh-oh! We couldn't find that page.</h1>
      <a className="is-text-white mt-4" href="/">
        Try dockethealth.com?
      </a>
      <img className="mt-4" src="/assets/images/error.png" />
    </div>
  );
};
